const get_alert_logs_count = customer => `/alert/logs/unviewed/${customer}`;
const get_alerts = customer => `/alert/get-alerts/${customer}`;
const get_alert_logs = customer => `/alert/logs/get/${customer}`;
const delete_alert = id => `/alert/delete/${id}`;
const create_alert = (customer, locationId) => `/alert/create/${customer}/${locationId}`;
const update_alert = id => `/alert/update/${id}`;
const mark_alert_as_viewed = uuid => `/alert/logs/mark/${uuid}`;
export const alertEndpoints = {
  get_alert_logs_count,
  get_alerts,
  get_alert_logs,
  delete_alert,
  create_alert,
  update_alert,
  mark_alert_as_viewed
};
